import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { toastStore } from 'shared/ui'
import { ChooseNumberTabsStore } from 'entities/Phone/ui/ChooseNumberTabs/store/ChooseNumberTabsStore'
import { ComplianceApi, type IResponseTollFree } from 'entities/Compliance'
import { ITabsEnum } from 'entities/Phone/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { BuyNumberRoutes } from 'pages/settings/pages/numbers/pages/BuyNumber'

export class ChooseNumberStore {
  private _chooseNumberTabsStore: ChooseNumberTabsStore
  private _useCases: IResponseTollFree[] = []
  private _selectedUseCaseId: number | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this._chooseNumberTabsStore = new ChooseNumberTabsStore(this._entities)
    this.loadUseCases()
  }

  get chooseNumberTabsStore() {
    return this._chooseNumberTabsStore
  }

  get useCases() {
    return this._useCases
  }

  get completedUseCases() {
    return this._useCases.filter((useCase) => useCase.completed)
  }

  get selectedUseCaseId() {
    return this._selectedUseCaseId
  }

  get useCaseNumberIds() {
    return this._useCases
      .find((useCase) => useCase.id === this.selectedUseCaseId)
      ?.numbers.map((number) => number.id)
  }

  get nextDisabled() {
    if (
      this.chooseNumberTabsStore.activeTab === ITabsEnum.TOLL_FREE &&
      this.completedUseCases.length &&
      this.selectedUseCaseId === null
    ) {
      return true
    }

    return !this.chooseNumberTabsStore.selectedNumber
  }

  setUseCase = (useCase: number) => {
    this._selectedUseCaseId = useCase
  }

  loadUseCases = async () => {
    try {
      const { data } = await ComplianceApi.getOrganizationTollFree()

      this._useCases = data.data
    } catch (error) {
      toastStore.add({
        type: 'error',
        title: 'Something went wrong. Please try again later.',
      })
      logger.error(error)
    }
  }

  nextClick = () => {
    uiStore.changeRoute({
      path: `${NumbersPath.buyNumber.steps}/${BuyNumberRoutes.assignNumber}`,
    })
  }
}
